// extracted by mini-css-extract-plugin
module.exports = {"container":"EmbeddedVideo_container__8V2gT","content":"EmbeddedVideo_content__SKhEh","headline":"EmbeddedVideo_headline__nSSbe","subHeadline":"EmbeddedVideo_subHeadline__2P7wU"};